/**
 * Per-level presentation tokens for the Magazine Manager.
 *
 * The three level sections (beginner / junior / senior) share the same markup
 * and behaviour but historically drifted apart on colours and on whether the
 * previous-issue Save/Cancel buttons show a text label. These tokens keep the
 * rendered output pixel-identical to the pre-refactor markup while allowing a
 * single shared component to drive all three.
 */
export const MAGAZINE_LEVELS = [
  {
    level: 'beginner',
    title: 'Beginner Level',
    cardBorderColor: 'rgba(255,107,53,0.3)',
    currentLinkInputSx: {
      '& .MuiOutlinedInput-root': {
        backgroundColor: '#fff',
        color: '#000',
      },
      '& .MuiInputBase-input': {
        color: '#000',
      },
    },
    currentLinkDisplayBg: 'rgba(31, 27, 27, 0.3)',
    previousHeadingColor: '#c64110',
    issueLabelColor: '#FFB74D',
    fieldLabelColor: '#FF6B35',
    fieldInputSx: {
      '& .MuiOutlinedInput-root': {
        backgroundColor: 'rgba(255,255,255,0.1)',
        color: '#fff',
      },
    },
    labelledFieldActions: true
  },
  {
    level: 'junior',
    title: 'Junior Level',
    cardBorderColor: 'rgba(255,165,0,0.3)',
    currentLinkInputSx: {
      '& .MuiOutlinedInput-root': { backgroundColor: 'rgba(255,255,255,0.1)', color: '#fff' }
    },
    currentLinkDisplayBg: 'rgb(45, 45, 45)',
    previousHeadingColor: '#06AED5',
    issueLabelColor: '#c64110',
    fieldLabelColor: '#c64110',
    fieldInputSx: {
      '& .MuiOutlinedInput-root': { backgroundColor: '#2d2d2d', color: '#fff' }
    },
    labelledFieldActions: false
  },
  {
    level: 'senior',
    title: 'Senior Level',
    cardBorderColor: 'rgba(220,20,60,0.3)',
    currentLinkInputSx: {
      '& .MuiOutlinedInput-root': { backgroundColor: 'rgb(45, 45, 45)', color: '#fff' }
    },
    currentLinkDisplayBg: 'rgb(45, 45, 45)',
    previousHeadingColor: '#06AED5',
    issueLabelColor: '#c64110',
    fieldLabelColor: '#c64110',
    fieldInputSx: {
      '& .MuiOutlinedInput-root': { backgroundColor: '#2d2d2d', color: '#fff' }
    },
    labelledFieldActions: false
  }
];

// Editable text fields on each previous issue (cover1 is handled by the uploader)
export const PREVIOUS_ISSUE_FIELDS = ['title', 'link1'];
